<template>
  <TableLayout :permissions="['business:information:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="标题" prop="title">
        <el-input v-model="searchForm.title" clearable placeholder="请输入标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="所属模块" prop="module">
        <el-select v-model="searchForm.module" clearable @change="search"  >
          <el-option :value="0" label="行业资讯"/>
          <el-option :value="1" label="运营经验"/>
          <el-option :value="2" label="功能介绍"/>
          <el-option :value="3" label="市场信息"/>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" clearable @change="search" placeholder="状态">
          <el-option label="正常" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:information:create', 'business:information:delete']">
        <li><el-button type="primary" @click="$refs.operaInformationWindow.open('新建动态资讯',null,searchForm.type)" icon="el-icon-plus" v-permissions="['business:information:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:information:delete']">删除</el-button></li>
      </ul>
      <el-table
          :height="tableHeightNew"
          v-loading="isWorking.search"
          :data="tableData.list"
          stripe
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="150px"></el-table-column>
        <el-table-column prop="releaseDate" label="发布时间" min-width="150px"></el-table-column>
        <el-table-column prop="imgurl" label="列表图" min-width="100px">
          <template slot-scope="{row}">
            <el-image v-if="row.fullImgurl" style="width: 60px; height: 60px" :src="row.fullImgurl"
                      :preview-src-list="[row.fullImgurl]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="简介" min-width="200px" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="jumpType" label="内容" align="center" min-width="150px">
          <template slot-scope="{row}">
            <span v-if=  "row.content!=null && row.content!=''"><el-button @click="showContentDo(row)" >查看内容</el-button></span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="module" label="所属模块" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.module == 0">行业资讯</span>
            <span v-if="row.module == 1">营经验</span>
            <span v-if="row.module == 2">功能介绍</span>
            <span v-if="row.module == 3">市场信息</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch @change="changeStatus($event, row)" v-model="row.status" active-color="#13ce66"
                       inactive-color="#ff4949" :active-value="0" :inactive-value="1">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="80px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="150px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="150px"></el-table-column>
        <el-table-column
            v-if="containPermissions(['business:information:update', 'business:information:delete'])"
            label="操作"
            min-width="120"
            fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaInformationWindow.open('编辑动态资讯', row,searchForm.type)" icon="el-icon-edit" v-permissions="['business:information:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:information:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaInformationWindow ref="operaInformationWindow" @success="handlePageChange"/>

    <el-dialog
        class="center-title"
        :title="showTitle||'显示内容'"
        width="70%"
        height="70%"
        text="内容"
        :visible.sync="visible1"
        append-to-body
    >
      <div class="agree-list"  v-html="showContent">
      </div>
      <template  v-slot:footer>
        <el-button @click="visible1=false">返回</el-button>
      </template>
    </el-dialog>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaInformationWindow from '@/components/business/OperaInformationWindow'
export default {
  name: 'Information',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaInformationWindow },
  data () {
    return {
      // 搜索
      visible1: false,
      showContent: '',
      showTitle: '',
      searchForm: {
        type:0,
        title: '',
        module: null,
        status: null
      }
    }
  },
  created () {
    this.config({
      module: '动态咨询',
      api: '/business/information',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    showContentDo (row) {
      this.showTitle = row.showTitle
      this.showContent = row.content
      this.visible1 = true
    },
    changeStatus (e, row) {
      this.canvisiting = true
      this.api.updateStatus({ id: row.id, status: e })
        .then(res => {
          this.$tip.apiSuccess(res || '操作成功')
          this.search()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.canvisiting = false
        })
        .catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
.agree-list{
  height: 550px;
  //max-height: 50%;
  overflow: auto;
}

/deep/ .window__body {
  .table-content {
    padding: 0;
    .table-wrap {
      padding-top: 0;
    }
  }

}
</style>
